import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Modal from '../molecules/Modal.js';
import Card from '../molecules/Card.js';

/**
 * Component component.
 * @extends {Base}
 */
export default class Single extends withBreakpointObserver(Base) {
  currentDisplay = 'landscape';

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Single',
    components: {
      Modal,
      Card,
    },
    options: {
      inactiveBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   *
   * @param {*} picture
   * @param {*} display
   */
  onCardOpenModal(picture, display) {
    this.$children.Modal[0].$children.ImageZoom[0].$refs.picture.classList.remove(
      this.currentDisplay,
    );
    this.$children.Modal[0].$children.ImageZoom[0].$refs.picture.classList.add(display);
    this.currentDisplay = display;

    this.$children.Modal[0].$children.ImageZoom[0].$refs.picture.src = picture;
    this.$children.Modal[0].open();
  }
}
